import { call, put, takeLatest } from "redux-saga/effects";
import { checkAuthorizationError, clearNotification, errorNotification, successNotification } from "../utils/notification-helpers";
import { DELETE_APPOINTMENT_REQUEST, DELETE_PATIENT_REQUEST, getAppointmentLength, getAppointmentSuccess, getMedicalHistorySuccess, getPatientDetailsSuccess, getPatientSuccess, GET_APPOINTMENT_FAILURE, GET_APPOINTMENT_REQUEST, GET_CONTACT_INFORMATION_FAILURE, GET_CONTACT_INFORMATION_REQUEST, GET_MEDICAL_HISTORY_FAILURE, GET_MEDICAL_HISTORY_REQUEST, GET_PATIENT_DETAIL_REQUEST, GET_PATIENT_FAILURE, GET_PATIENT_REQUEST, postContactInformationRequest, postContactInformationSuccess, postMedicalHistoryRequest, postMedicalHistorySuccess, postPatientSuccess, POST_CONTACT_INFORMATION_FAILURE, POST_CONTACT_INFORMATION_REQUEST, POST_MEDICAL_HISTORY_FAILURE, POST_MEDICAL_HISTORY_REQUEST, POST_PATIENT_FAILURE, POST_PATIENT_REQUEST, POST_REFERAL_INFORMATION_FAILURE, POST_REFERAL_INFORMATION_REQUEST, getPatientRequest, getAppointmentRequest, PUT_PATIENT_REQUEST, GET_ALL_APPOINTMENT_REQUEST, getAllAppointmentSuccess, getAllAppointmentRequest, getContactInformationSuccess, appendAppointmentList } from "../actions/patientAction";
import { createContactInformationAPICall, createPatientDetailAPICall, deleteAppointmentAPICall, deletePatientAPICall, getAppointmentDetailAPICall, getAppointmentNoShowAPICall, getAppointmentPatientDetailAPICall, getContactInformationAPICall, getMedicalDetailAPICall, getPatientDetailAPICall,  patientDetailsAPICall,  postMedicalDetailAPICall, putContactInformationAPICall, putMedicalDetailAPICall, putPatientDetailAPICall, referralDetailsAPICall } from "../apis/patientCallApi";
import moment from "moment";
import history from "../routers/history";



function* getPatientHandler({ payload }) {
  try {
    const { patientSearch, setVisible, isDateTrue, facility_id } = payload || {}
    let searchPatientValue = false
    if (patientSearch && Object.keys(patientSearch)?.length) {
      searchPatientValue = {
        phone: patientSearch?.mobilenumber ? patientSearch?.mobilenumber : undefined,
        patient_id: patientSearch?.patient_id ? patientSearch?.patient_id : undefined,
        name: patientSearch?.name ? patientSearch?.name : undefined,
        unique_patient_id: patientSearch?.unique_patient_id ? patientSearch?.unique_patient_id : undefined,
        facility_id: patientSearch?.facility_id ? patientSearch?.facility_id : undefined
      }
    }
    if(isDateTrue){
      searchPatientValue = { end_appointment_date_time: isDateTrue?.end_appointment_date_time, start_appointment_date_time: isDateTrue?.start_appointment_date_time, facility_id: facility_id }
    }
    const { responseStatus, responseJSON } = yield call(getPatientDetailAPICall, searchPatientValue ? searchPatientValue : {})

    if (responseStatus >= 200 && responseStatus < 300) {
      yield put(getPatientSuccess(responseJSON))
    } else if (responseStatus === 401) {
      throw Error(responseStatus);
    } else if (responseStatus === 404) {
      delete searchPatientValue.facility_id
      const { responseStatus: responseStatusAppointmentPatient, responseJSON: responseJSONAppointmentPatient } = yield call(getAppointmentPatientDetailAPICall, searchPatientValue ? searchPatientValue : {})
      if (responseStatusAppointmentPatient >= 200 && responseStatusAppointmentPatient < 300) {
        yield put(getPatientSuccess(responseJSONAppointmentPatient))
      } else if (responseStatusAppointmentPatient === 401) {
        throw Error(responseStatusAppointmentPatient);
      } else if (responseStatusAppointmentPatient === 404) {
        yield put(getPatientSuccess([]))
        errorNotification("There are no patients checked in matching that date or name.")
        if (setVisible) setVisible(true)
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_PATIENT_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * deletePatientHandler ({ payload }) {
  try {
    const {afterScucess, guid} = payload || {}
    const { responseStatus, responseJSON } = yield call(deletePatientAPICall, guid)
    if(responseStatus >= 200 && responseStatus < 300){
      clearNotification()
      successNotification("Patient Deleted Successfully")
      yield put(getPatientRequest({}))
      afterScucess(false)
    } 
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_PATIENT_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getPatientDetailsHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(patientDetailsAPICall, payload ? payload : {})
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getPatientDetailsSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_PATIENT_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * getAllAppointmentHandler ({ payload, filterDate }) {
  try {
    const { facility_id, currentTab, name, isDateTrue, filterDate, id, patient_id } = payload || {}

    yield put(getAllAppointmentSuccess([]))
    let appointment_status = undefined
    if (currentTab) {
      if (currentTab === "checked-in") {
        appointment_status = "Checked-In"
      } else if (currentTab === "no-show") {
        appointment_status = "No-Show"
      } else if (currentTab === "cancelled") {
        appointment_status = "Cancelled"
      }
    }
      const { responseStatus: responseOk, responseJSON: completeJson } = yield call(getAppointmentDetailAPICall, { facility_id: facility_id })
      const { responseStatus: patientResponseOk, responseJSON: patientCompleteJson } = yield call(getAppointmentDetailAPICall, { facility_id: facility_id, source_application: "patient app", })
      if (responseOk) {
        const appointmentLengthData = {
          allPatient: completeJson?.length || 0,
          checkInPatient: completeJson?.length ? completeJson?.filter(element => element.appointment_status === "Checked-In")?.length : 0,
          scanComplete: completeJson?.length ? completeJson?.filter(element => element.appointment_status === "completed")?.length : 0,
          allPatientData: completeJson || []
        }

        if (patientResponseOk) {
          appointmentLengthData.allPatient = patientCompleteJson?.length ? appointmentLengthData.allPatient + patientCompleteJson.length : appointmentLengthData.allPatient
          appointmentLengthData.checkInPatient = patientCompleteJson?.length ? appointmentLengthData.checkInPatient + patientCompleteJson.filter(element => element.appointment_status === "Checked-In")?.length : appointmentLengthData.checkInPatient
          appointmentLengthData.scanComplete = patientCompleteJson?.length ? appointmentLengthData.scanComplete + patientCompleteJson?.filter(element => element.appointment_status === "completed")?.length : appointmentLengthData.scanComplete
        }
        yield put(getAppointmentLength(appointmentLengthData))
      }
      const { responseStatus, responseJSON } = yield call(getAppointmentDetailAPICall, { facility_id: facility_id, appointment_status, name, ...filterDate, ...isDateTrue, patient_id, id })

      if (responseStatus >= 200 && responseStatus < 300) {
        yield put(getAllAppointmentSuccess(responseJSON))
        yield put(appendAppointmentList(responseJSON))
      } else if (responseStatus === 401) {
        throw Error(responseStatus);
      } else if (responseStatus === 404) {
        yield put(getAppointmentSuccess([]))
      }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_APPOINTMENT_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getAppointmentHandler ({ payload }) {
  try {
    const { facility_id, currentTab, isDateTrue, name,  } = payload || {}


      if (!currentTab || currentTab === "all") {
        const { responseStatus, responseJSON } = yield call(getAppointmentDetailAPICall, { facility_id: facility_id, name, ...isDateTrue })
        if(responseStatus >= 200 && responseStatus < 300){
          yield put(getAppointmentSuccess(responseJSON))
          console.log("responseJSON", responseJSON)
          yield put(getAllAppointmentRequest({ facility_id: facility_id }))
        } else if(responseStatus === 401){
          throw Error(responseStatus);
        } else if(responseStatus === 404){
          yield put(getAppointmentSuccess([]))
        }
      } else {
        let appointment_status = "Scheduled"
        if (currentTab === "checked-in") {
          appointment_status = "Checked-In"
        } else if (currentTab === "no-show") {
          appointment_status = "No-Show"
        } else if (currentTab === "cancelled") {
          appointment_status = "Cancelled"
        }else if (currentTab === "Completed") {
          appointment_status = "Completed"
        }
        let responseStatusAppointment
        let responseJsonAppointment
        if(currentTab === "no-show"){
          const { responseStatus, responseJSON } = yield call(getAppointmentNoShowAPICall)
          responseStatusAppointment = responseStatus
          responseJsonAppointment = responseJSON
        } else {
          const { responseStatus, responseJSON } = yield call(getAppointmentDetailAPICall, { facility_id: facility_id, appointment_status, name, ...isDateTrue })
          responseStatusAppointment = responseStatus
          responseJsonAppointment = responseJSON
        }
        if(responseStatusAppointment >= 200 && responseStatusAppointment < 300){
          yield put(getAppointmentSuccess(responseJsonAppointment))
        } else if(responseStatusAppointment === 401){
          throw Error(responseStatusAppointment);
        }else if(responseStatusAppointment === 404){
          yield put(getAppointmentSuccess([]))
        }
      }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_APPOINTMENT_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * deleteAppointmentHandler ({ payload }) {
  try {
    const { appointment_status, id, facility_id} = payload
    const { responseStatus, responseJSON } = yield call(deleteAppointmentAPICall, id )
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getAppointmentRequest({appointment_status: appointment_status , facility_id: facility_id}))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: "",
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * postContactInformationHandler ({ payload }) {
  try {
    const {addresses,identification, patient_id, facilityId, emergency_contact }= payload
    const contact_information = {
      addresses: addresses || [],
      phone_numbers: [],
      identification: identification || [],
      emergency_contact: emergency_contact || [],
      patient_id: patient_id || "",
      health_check_plan: "Premium",
      facility_id: facilityId || "",
    }
    const { responseStatus, responseJSON } = yield call(createContactInformationAPICall, contact_information)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(postContactInformationSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: POST_CONTACT_INFORMATION_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getContactInformationHandler ({ payload }) {
  try {
    const {addresses,identification, phone_numbers, patient_id, facilityId, onlyData, emergency_contact }= payload
      const { responseStatus, responseJSON } = yield call(getContactInformationAPICall, {patient_id: patient_id})
      if(responseStatus >= 200 && responseStatus < 300){
        getContactInformationSuccess(responseJSON)
        if(!onlyData){
          yield put(putContactInformationAPICall({
            ...responseJSON[0],
            addresses: addresses,
            identification: identification,
            phone_numbers: phone_numbers,
            patient_id: patient_id,
            health_check_plan: "Premium",
            facility_id: facilityId,
            emergency_contact
          }))
        }
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }else if(responseStatus === 404){
        yield put (getContactInformationSuccess([]))
        if(!onlyData){
          yield put(postContactInformationRequest({...payload, updated: true}))
        }
        
      }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_CONTACT_INFORMATION_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getMedicalDetailHandler ({ payload }) {
  try {
    const {patient_id, additional_detail, surgery, allergies, facilityId, onlyData, medications} = payload
    const alergyItem = (allergies?.length && allergies?.map( e => Object.keys(e) )) || []
    const { responseStatus, responseJSON } = yield call(getMedicalDetailAPICall, {patient_id: patient_id})
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getMedicalHistorySuccess(responseJSON))
      if(!onlyData){
        yield call(putMedicalDetailAPICall({
          ...responseJSON[0],
          additional_detail, surgery, 
          allergies:alergyItem?.length ? [{name: alergyItem[0][0], detail: allergies[0].iodine === "Y" ? "true" : "false" }, {name: alergyItem[1][0], detail: allergies[1].barium === "Y" ? "true" : "false" }, {name: alergyItem[2][0], detail: allergies[2].metalallergies === "Y" ? "true" : "false" }]: null,
          id: responseJSON[0]?.id,
          facility_id: facilityId,
          medications
        }))
      }
      
    } else if(responseStatus === 404){
      yield put (getMedicalHistorySuccess([]))
      if(!onlyData){
        yield put(postMedicalHistoryRequest({...payload, updated: true}))
      }
      
    }
     else if(responseStatus === 401){
      throw Error(responseStatus);
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_MEDICAL_HISTORY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * postMedicalDetailHandler ({ payload }) {
  try {
    const {patient_id, additional_detail, surgery, medications, allergies, facilityId, actionValue, afterSuccess, scheduleOpen, updated } = payload
    const alergyItem =  (allergies?.length && allergies?.map( e => Object.keys(e) )) || []
    const medical_history = {
      patient_id: patient_id,
      additional_detail: additional_detail,
      surgery: surgery,
      medications: medications,
      allergies:alergyItem?.length ? [{name: alergyItem[0][0], detail: allergies[0].iodine === "y" ? "true" : "false" }, {name: alergyItem[1][0], detail: allergies[1].barium === "y" ? "true" : "false" }, {name: alergyItem[2][0], detail: allergies[2].metalallergies === "y" ? "true" : "false" }]: [],
      facility_id: facilityId,
    }

    const { responseStatus, responseJSON } = yield call(postMedicalDetailAPICall, medical_history)
    if(responseStatus >= 200 && responseStatus < 300){
      successNotification("Medical History is Created")
      yield put(postMedicalHistorySuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
    if(!updated){
      if(actionValue !== "walk-in" && scheduleOpen){
        history.push(`/appointment?patientguid=${patient_id}`)
      } else if(scheduleOpen) {
        afterSuccess(scheduleOpen)
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: POST_MEDICAL_HISTORY_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * postReferralDetailsHandler ({ payload }) {
  try {
    const {referring_physician, patient_id, facilityId, referring_facility, internalPhysician, externalPhyscian, internalSourceFacility, externalSourceFacility, scheduleOpen, afterSuccess, phone, actionValue, updated } = payload
    let referringPhysician = referring_physician && referring_physician[0] === 'external-physician-guid' ?  externalPhyscian : internalPhysician;
    let referringFacility = referring_facility && referring_facility[0] === 'external-facility-guid' ?  externalSourceFacility : internalSourceFacility

    const refferingFaciltyData = referringFacility?.find(value=> referring_facility?.length && (value.guid === referring_facility[1]))
    const refferingPhysicianData = referringPhysician?.find(value=> referring_physician?.length && (value.guid === referring_physician[1]))

    const referralinformation = {
      referring_facility: refferingFaciltyData?.name || "",
      referring_physician: refferingPhysicianData?.full_name || "",
      physician_id: referring_physician?.length ? referring_physician[1] : "",
      physician_name: refferingPhysicianData?.full_name || "",
      phone_number: phone || "",
      email: refferingPhysicianData?.email,
      patient_id: patient_id,
      facility_id: facilityId,
    }
    if(refferingPhysicianData?.email && (referring_physician?.length && referring_physician[1]) ){
      const { responseStatus, responseJSON } = yield call(referralDetailsAPICall, referralinformation)
      if(responseStatus >= 200 && responseStatus < 300){
        clearNotification()
        successNotification("Referral is Created")
        yield put(getPatientDetailsSuccess(responseJSON))
      }
    }
    if(!updated){
      if(scheduleOpen){
        if(actionValue !== "walk-in"){
          history.push(`/appointment?patientguid=${patient_id}`)
        } else {
          afterSuccess(scheduleOpen)
        }
      } else {
        history.push("/")
      }
    } 

  } catch (e) {
    console.error(e)
    yield put({
      type: POST_REFERAL_INFORMATION_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * postPatientHandler ( { payload } ) {
  try {
    const {  email, last_name, middle_name, gender,  first_name,  marital_status, title, dob, phone, policy_number, scheduleOpen, unique_patient_id, flowCurrent, afterSuccess, afterCreate, actionValue, facilityId, addresses, identification, emergency_contact } = payload || {}
    const patientCreate = {
      first_name: first_name,
      marital_status: marital_status,
      middle_name: middle_name,
      gender: gender,
      title: title,
      phone: phone,
      last_name: last_name,
      unique_patient_id: unique_patient_id,
      allowed_facility: [{facility_id:facilityId, object_id:unique_patient_id}],
      dob: moment(dob, "DD MMM YYYY").unix(),
      insurance: {
        policy_number: policy_number,
        policy_holder_name: first_name +" " + last_name,
      },
      contact_information: {
        addresses: addresses || [],
        identification: identification || [],
        emergency_contact: emergency_contact || []
      }
    }

    const { responseStatus, responseJSON } = yield call(createPatientDetailAPICall,{...patientCreate })
      if(responseStatus >= 200 && responseStatus < 300){
        clearNotification()
        successNotification("Patient Successfully Created")
        yield put(postPatientSuccess(responseJSON))
        if(afterCreate){
          afterCreate(responseJSON?.patient_id, responseJSON )
        }

        if(actionValue !== "walk-in" && scheduleOpen){
          history.push(`/appointment?patientguid=${responseJSON?.patient_id}`)
        } else if (scheduleOpen) {
          afterSuccess(scheduleOpen)
        }
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }
  } catch (e) {
    console.error(e)
    yield put({
      type: POST_PATIENT_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * putPatientHandler ( { payload } ) {
  try {
    const {  last_name, middle_name, gender,  first_name,  marital_status, title, dob, phone, policy_number, scheduleOpen, unique_patient_id, patient_id, appointmentPage, id, facilityId, addresses, identification, emergency_contact, referring_physician, externalPhyscian, internalPhysician, referring_facility, externalSourceFacility, internalSourceFacility, returnPage, actionValue, afterSuccess } = payload || {}

    let referringPhysician = referring_physician && referring_physician[0] === 'external-physician-guid' ?  externalPhyscian : internalPhysician;
    let referringFacility = referring_facility && referring_facility[0] === 'external-facility-guid' ?  externalSourceFacility : internalSourceFacility
    const { responseStatus, responseJSON } = yield call(putPatientDetailAPICall,{
      allowed_facility: [{facility_id : facilityId}],
      first_name,
      id,
      marital_status,
      middle_name,
      gender,
      title,
      phone,
      last_name,
      unique_patient_id,
      patient_id,
      dob: moment(dob, "DD MMM YYYY").unix(),
      contact_information: {
        addresses: addresses || [],
        identification: identification || [],
        emergency_contact: emergency_contact || []
      },
      referral_details: {
        referring_facility: referringFacility?.find(value=> value.guid === referring_facility[1])?.name,
        referring_physician: referringPhysician?.find(value=> value.guid === referring_physician[1])?.full_name,
        physician_name: referringPhysician?.find(value=> value.guid === referring_physician[1])?.full_name,
        physician_id: referring_physician[1],
        phone_number: phone ,
      },
      insurance: {
        policy_number: policy_number,
        policy_holder_name: first_name +" " + last_name,
      },
    })
      if(responseStatus >= 200 && responseStatus < 300){
        clearNotification()
        successNotification("Patient Updated Successfully")
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }
      if(actionValue !== "walk-in" && scheduleOpen){
        history.push(`/appointment?patientguid=${responseJSON?.patient_id}`)
      } else if (scheduleOpen) {
        history.push(`/appointment?patientguid=${responseJSON?.patient_id}`)
        afterSuccess(scheduleOpen)
      }
      
    if(returnPage) history.push('/patients')
  } catch (e) {
    console.error(e)
    yield put({
      type: POST_PATIENT_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

export function * patientSaga () {
  yield takeLatest(GET_PATIENT_REQUEST, getPatientHandler)
  yield takeLatest(GET_MEDICAL_HISTORY_REQUEST, getMedicalDetailHandler)
  yield takeLatest(POST_MEDICAL_HISTORY_REQUEST, postMedicalDetailHandler)
  yield takeLatest(POST_CONTACT_INFORMATION_REQUEST, postContactInformationHandler)
  yield takeLatest(GET_CONTACT_INFORMATION_REQUEST, getContactInformationHandler)
  yield takeLatest(POST_REFERAL_INFORMATION_REQUEST, postReferralDetailsHandler)
  yield takeLatest(GET_PATIENT_DETAIL_REQUEST, getPatientDetailsHandler)
  yield takeLatest(DELETE_APPOINTMENT_REQUEST, deleteAppointmentHandler)
  yield takeLatest(GET_APPOINTMENT_REQUEST, getAppointmentHandler)
  yield takeLatest(POST_PATIENT_REQUEST, postPatientHandler)
  yield takeLatest(DELETE_PATIENT_REQUEST, deletePatientHandler)
  yield takeLatest(PUT_PATIENT_REQUEST, putPatientHandler)
  yield takeLatest(GET_ALL_APPOINTMENT_REQUEST, getAllAppointmentHandler)
}
  